import { Component, input } from '@angular/core';
import { IconCheckComponent } from '../icon-check/icon-check.component';

@Component({
  selector: 'app-icon-circle-check',
  standalone: true,
  imports: [IconCheckComponent],
  templateUrl: './icon-circle-check.component.html',
  styleUrl: './icon-circle-check.component.scss'
})
export class IconCircleCheckComponent {
  circleColor = input.required<string>();
}
